import { format as _format, subYears as _subYears, setDefaultOptions } from 'date-fns';
import { ja } from 'date-fns/locale';

setDefaultOptions({
  // 日本語設定
  locale: ja,
  // 日曜始まり
  weekStartsOn: 0,
});

export const dateFns = {
  format: _format,
  subYears: _subYears,
};

export const Format = {
  date: 'yyyy.MM.dd',
  dateJa: 'yyyy年MM月dd日',
  dateTime: 'yyyy.MM.dd HH:mm',
  dateTimeRequest: 'yyyy-MM-dd HH:mm:ss',
  dateTimeJa: 'yyyy年MM月dd日 HH時mm分',
  dateTimeLotteryJa: 'yyyy年MM月dd日 HH:mm',
  dateTimeJaIncDOW: 'yyyy.MM.dd (E) HH:mm',
  dateIncDOW: 'MM/dd (E)',
  dateCardExpired: 'MM/yy',
};

export type DateFormat = (typeof Format)[keyof typeof Format];
